import { render, staticRenderFns } from "./EditFormalizacionActas.vue?vue&type=template&id=d72f346c&scoped=true"
import script from "./EditFormalizacionActas.vue?vue&type=script&lang=js"
export * from "./EditFormalizacionActas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72f346c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d72f346c')) {
      api.createRecord('d72f346c', component.options)
    } else {
      api.reload('d72f346c', component.options)
    }
    module.hot.accept("./EditFormalizacionActas.vue?vue&type=template&id=d72f346c&scoped=true", function () {
      api.rerender('d72f346c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/tasks/EditFormalizacionActas.vue"
export default component.exports